import {
  Avatar,
  Box,
  Circle,
  Flex,
  HStack,
  Link,
  Menu,
  MenuItem,
  MenuList,
  Text,
  useMenuButton,
  UseMenuButtonProps,
} from "@chakra-ui/react";

import { useNavigate } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import { MaterialIcon } from "./MaterialIcon";

export const UserAvatar = () => {
  const { userProfile } = useAuth();

  return (
    <Circle bg={"primary.300"} p={1}>
      <Avatar
        size="sm"
        bg={"bg.main"}
        // src={userProfile?.BrandImageUrl}
        color={"text"}
        name={`${userProfile?.first_name} ${userProfile?.last_name}`}
      />
    </Circle>
  );
};

const ProfileMenuButton = (props: UseMenuButtonProps) => {
  const buttonProps = useMenuButton(props);
  return (
    <Flex
      {...buttonProps}
      as="button"
      flexShrink={0}
      shadow="md"
      rounded="full"
      outline="0"
      _focus={{ shadow: "outline" }}
    >
      <Box srOnly>Open user menu</Box>
      <UserAvatar />
    </Flex>
  );
};

export const ProfileDropdown = () => {
  const { userProfile, logout } = useAuth();
  const navigate = useNavigate();

  const handleSignout = async (values) => {
    try {
      await logout();
      // Startup amplitude
      navigate("/");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Menu>
      <ProfileMenuButton />
      <MenuList
        zIndex="100"
        rounded="sm"
        // shadow="lg"
        py="1"
        bg={"bg.main"}
        color={"text"}
        fontSize="sm"
      >
        <HStack px="3" py="4">
          <UserAvatar />
          <Box lineHeight="1">
            <Text fontWeight="semibold">
              {`${userProfile?.first_name} ${userProfile?.last_name}`}
            </Text>
            <Text mt="1" fontSize="xs" color={"text.soft"}>
              {userProfile?.email}
            </Text>
          </Box>
        </HStack>
        <MenuItem textStyle={"navLink"}>
          <Link
            as={RouterLink}
            w="full"
            to="/app/settings/profile"
            _hover={{
              textDecor: "none",
            }}
          >
            Your Profile
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            w="full"
            isExternal
            textStyle={"navLink"}
            _hover={{ textDecoration: "none" }}
            href="https://geneial.com/contact/"
          >
            <HStack spacing="4" justifyContent={"space-between"}>
              <Text as="span">Contact us</Text>
              <MaterialIcon name="link" fontSize="1rem" opacity={0.64} />
            </HStack>
          </Link>
        </MenuItem>
        <MenuItem
          onClick={handleSignout}
          textStyle={"navLink"}
          color={"danger"}
        >
          <HStack w="full" spacing="4" justifyContent={"space-between"}>
            <Text textStyle={"navLink"} as="span">
              Sign out
            </Text>
            <MaterialIcon name="logout" fontSize="1rem" opacity={0.64} />
          </HStack>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
